import { render, staticRenderFns } from "./List-Categories.vue?vue&type=template&id=66013fa6"
import script from "./List-Categories.vue?vue&type=script&lang=js"
export * from "./List-Categories.vue?vue&type=script&lang=js"
import style0 from "./List-Categories.vue?vue&type=style&index=0&id=66013fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports